import { COLORS } from 'constants/colors'
import { device } from 'constants/responsive'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  height: 100%;
  max-height: 560px;

  & > div {
    width: calc(50% - 7px);
    border: 1px solid #ebebeb;
    border-radius: 12px;

    padding: 25px 24px;

    &:first-child {
      margin-right: 14px;

      @media ${device.laptop} {
        margin-right: 0;
        margin-bottom: 14px;
      }
    }

    @media ${device.laptop} {
      height: 400px;
      width: 100%;
    }
  }

  @media ${device.laptop} {
    display: block;
    height: auto;
    max-height: none;
  }
`

export const Title = styled.h3`
  font-weight: 500;
  font-size: 20px;
  line-height: 1.2;
  color: ${COLORS.text.default};
`
